import { Button, ButtonGroup } from '@apollo/orbit';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { getOnboardingVariant } from 'src/lib/analytics/amplitude/helpers/getOnboardingVariant';
import { ampli } from 'src/lib/analytics/amplitude/vendor';
import Config from 'src/lib/config';
import { DocsRouter } from 'src/lib/routers/docs';
import { setOverlayVisibleLocation } from 'src/lib/routing';

export const DemoCallToAction = ({
  planName,
}: {
  planName: string | undefined;
}) => {
  const location = useLocation();
  const history = useHistory();
  return (
    <ButtonGroup>
      <Button
        as="a"
        target="_blank"
        rel="noopener"
        href={DocsRouter.path('FederationQuickstart')}
        size="md"
        variant="secondary"
        onClick={async () => {
          ampli.createDemoGraphClicked({
            OnboardingVariant: getOnboardingVariant(planName),
          });
          ampli.connectGraphFlowStarted({
            'API Type': 'GraphQL',
          });
        }}
      >
        Set up a demo environment
      </Button>
      <Button
        size="md"
        onClick={async () => {
          ampli.connectGraphFlowStarted({
            'API Type': 'REST',
            OnboardingVariant: getOnboardingVariant(planName),
          });

          history.push(
            setOverlayVisibleLocation({
              location,
              overlayName: Config.modals.createGraph,
            }),
          );
        }}
      >
        Connect an existing graph
      </Button>
    </ButtonGroup>
  );
};
